import { render, staticRenderFns } from "./SnackbarQV.vue?vue&type=template&id=ed0c29e8&scoped=true&"
import script from "./SnackbarQV.vue?vue&type=script&lang=js&"
export * from "./SnackbarQV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0c29e8",
  null
  
)

export default component.exports